import { observer } from "mobx-react-lite";
import { Flex, FlexProps } from "@chakra-ui/react";

import { useSelecting } from "@noli/business";

import { FiltersPanel, SvgColorsPanel } from "./common";

function SVGEditor(props: FlexProps) {
  const node = useSelecting("raw").displayNode;
  if (node?.type !== "svg") {
    return null;
  }
  return (
    <Flex w="100%" h="100%" direction="column" {...props}>
      <SvgColorsPanel />
      <FiltersPanel alias={node.alias} flex={1} excludedFilters={["hue"]} />
    </Flex>
  );
}

export default observer(SVGEditor);
